module.exports = __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo_client_white-a0fef42976211d45665d7ed57bb89981.png";